import React from 'react'
import { Box, Typography } from '@mui/material'

import { TooltipSeeker } from '@ui-seeker/core'

// Green (best rank) → amber → red (worst rank).
const SCALE = [[30, 158, 107], [242, 201, 76], [224, 82, 79]]

const lerp = (from, to, t) => from.map((v, i) => Math.round(v + (to[i] - v) * t))

const rankColor = fraction => {
	const [from, to, t] = fraction < .5
		? [SCALE[0], SCALE[1], fraction / .5]
		: [SCALE[1], SCALE[2], (fraction - .5) / .5]

	const [r, g, b] = lerp(from, to, t)
	return `rgb(${r},${g},${b})`
}

const shortDate = date => `${String(date).slice(6, 8)}/${String(date).slice(4, 6)}`

/**
 * One cell per date with the main brand's market rank, coloured from green
 * (cheapest) to red (most expensive) relative to the number of brands tracked.
 */
export default function RankStrip({ rows, totalBrands }) {
	const cells = rows.filter(({ rank }) => typeof rank === 'number')

	if (!cells.length) return null

	return <Box sx={{ mt: 1, px: 1 }}>
		<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 'bold' }}>
			Main rank by pickup date
		</Typography>
		<Box sx={{ display: 'flex', gap: .5, mt: .5 }}>
			{rows.map(({ date, rank, brands }) => {
				// Normalised against the brands quoting that date: being last of two
				// is the worst spot available, whatever the tracked total is.
				const dayBrands = brands || totalBrands
				const span = dayBrands > 1 ? dayBrands - 1 : 1

				return <Box key={date} sx={{ flex: 1, minWidth: 0 }}>
				<TooltipSeeker title={typeof rank === 'number'
					? `${shortDate(date)} — rank ${rank} of ${dayBrands}`
					: `${shortDate(date)} — no rate`}>
					<Box sx={{
						borderRadius: 1,
						py: .5,
						textAlign: 'center',
						fontSize: 12,
						fontWeight: 'bold',
						color: typeof rank === 'number' ? '#fff' : 'text.disabled',
						backgroundColor: typeof rank === 'number'
							? rankColor(Math.min(1, Math.max(0, (rank - 1) / span)))
							: 'background.grey',
					}}>
						{typeof rank === 'number' ? rank : '—'}
					</Box>
				</TooltipSeeker>
				<Typography
					variant="caption"
					sx={{ display: 'block', textAlign: 'center', color: 'text.disabled', fontSize: 9.5 }}>
					{shortDate(date)}
				</Typography>
			</Box>
			})}
		</Box>
	</Box>
}
